<template>
  <mdb-container fluid>
    <mdb-row>
      <mdb-col>
        <div
          :class="{
            'special-color': false,
            legend: !isFixed,
            'fixed-legend': isFixed
          }"
        >
          <div v-if="!isFixed" class="legend-title">
            <p class="heading-color">LEGEND</p>
          </div>
          <mdb-row>
            <mdb-col
              lg="12"
              col="12"
              md="4"
              sm="6"
              :class="{
                'legend-content': !isFixed,
                'fixed-legend-content': isFixed
              }"
              v-for="(item, key) in services"
              :key="key"
            >
              {{ item.name }}
              <mdb-icon
                :class="{
                  'panel-icon': !isFixed,
                  'fixed-legend-icon': isFixed
                }"
                :icon="icons[item.name.toLowerCase().replace(' ', '')]"
              />
            </mdb-col>
          </mdb-row>
        </div>
      </mdb-col>
    </mdb-row>
  </mdb-container>
</template>

<script>
import { getServices } from "../common/dataSourceIntegrationService";
import { ICONS } from "../common/constants";
export default {
  name: "LegendBox",
  props: ["isFixed"],
  data() {
    return { services: getServices(), icons: ICONS };
  },
  components: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.sticky-legend {
  @media (max-width: 768px) {
    margin: 50px -15px 0;
  }
}
.legend {
  position: relative;
  display: contents;
  background: #fff;
  box-shadow: 0 1px 7px rgba(0, 0, 0, 0.1);
  color: black;
  width: 100%;
  border: 0px;
  border-radius: 10px;
  opacity: 1;
  padding: 0 10px 15px;
}
.legend-content {
  text-align: left;
  font-size: 0.95em;
}
.fixed-legend {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  background: #fff;
  color: black;
  padding-bottom: 15px;
  border-bottom: solid 0.02px rgb(230, 229, 229);
  margin: auto;
  border-bottom: 1px solid #e2e7ec;
  background-color: #f5f7f9;
  border-radius: 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 15px;
}
.fixed-legend-content {
  display: inline-block;
  font-size: 0.95rem;
  margin: 0 10px;
  padding: 5px;
  flex-shrink: 10;
  flex: auto;
  width: auto;
  min-width: 100px;
}
.fixed-legend-icon {
  margin-left: 2px;
  margin-right: 2px;
  color: #5586ab;
}
.legend-title p {
  padding: 10px 0 5px;
  margin: 0 0 10px;
  font-weight: bold;
  font-size: 0.9rem;
  letter-spacing: 1px;
  border-bottom: solid 1px #ebf0f2;
  @media (max-width: 768px) {
    margin-bottom: 20px;
  }
}
.panel-icon {
  width: 20px;
  text-align: center;
  color: #5586ab;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .fixed-legend {
    font-size: 0.8em;
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (max-width: 768px) {
  .fixed-legend {
    font-size: 0.8em;
  }
}
/* Large devices (desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .legend {
    display: block;
    width: 133%;
    margin-left: -33%;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .legend {
    display: block;
    width: 120%;
    margin-left: -20%;
  }
}
</style>
